export default __webpack_public_path__ + "static/media/home_bg_vid_nsl_trl.528296f1.mp4";